// Coordinates "the page is on screen and nothing covers it any more", so entrance
// animations can start when someone will actually see them instead of at mount.
//
// Things that cover the page (boot, the intro loader, the page-transition overlay)
// register a blocker; `pageReady.ready` resolves once every blocker is released.
// Blockers can release a little BEFORE their real end (`releaseIn`), so the entrances
// chain onto the end of the cover instead of waiting for it to be fully gone.
//
//   const b = pageReady.block("loader");
//   b.releaseIn(seconds)  // release `seconds - lead` from now (the cover's remaining time)
//   b.release()           // release now (idempotent)
//
//   pageReady.ready.then(() => playEntrance());
//
// Blockers must be registered before the last one is released: `boot` (app.js)
// covers the gap while components construct and register theirs.

const LEAD = 0.2; // seconds before a cover's end at which the page counts as ready
const TIMEOUT = 8; // seconds: a blocker never released can't hold the page forever

const blockers = new Set();
let settled = false;
let resolveReady;
const ready = new Promise((r) => (resolveReady = r));

function log(...args) {
  if (import.meta.env.DEV) console.log("[page-ready]", ...args);
}

function check() {
  if (settled || blockers.size) return;
  settled = true;
  document.documentElement.classList.add("is-page-ready");
  log("ready");
  resolveReady();
}

export const pageReady = {
  ready,
  lead: LEAD,

  get isReady() {
    return settled;
  },

  block(name) {
    const token = { name };
    blockers.add(token);
    log("blocked by", name);

    let done = false;
    let timer = null;
    const release = () => {
      if (done) return;
      done = true;
      clearTimeout(timer);
      clearTimeout(fallback);
      blockers.delete(token);
      log("released", name);
      check();
    };
    const fallback = setTimeout(() => {
      log("timeout, force-releasing", name);
      release();
    }, TIMEOUT * 1000);

    return {
      release,
      releaseIn(seconds) {
        clearTimeout(timer);
        timer = setTimeout(release, Math.max(0, seconds - pageReady.lead) * 1000);
      },
    };
  },
};
